<template>
  <div class="list-item-description-icon">
    <div class="item">
      <div class="qualification-icon">
        <inline-svg :src="require('@/assets/svg/qualification-icon.svg')" />
      </div>
      <div class="description" v-if="isPlaceholder">
        <div class="d-flex flex-column mr-2">
          <span class="font-weight-bold">
            Previous Educational Institution
          </span>
        </div>
        <span>-/-/- - -/-/-</span>
      </div>
      <div class="description" v-else>
        <div class="d-flex flex-column mr-2">
          <span class="font-weight-bold">
            {{ qualification.qualificationType }} -
            {{ qualification.qualificationSubject }}
            ({{ qualification.qualificationGrade }})
          </span>
          <span> {{ qualification.qualificationInstitution }} </span>
        </div>
        <span> {{ dateRange }} </span>
      </div>
    </div>
  </div>
</template>

<script>
import { getDateRange, isValidDateRange } from "@/utils/time";
import InlineSvg from "vue-inline-svg";

export default {
  name: "QualificationListItem",
  components: { InlineSvg },
  props: {
    qualification: {
      type: Object,
      required: true
    },
    isPlaceholder: Boolean
  },
  computed: {
    dateRange() {
      const { dateStarted, dateCompleted } = this.qualification;
      if (!isValidDateRange([dateStarted, dateCompleted])) {
        return "-/-/-";
      }
      return getDateRange({
        startDate: dateStarted,
        endDate: dateCompleted,
        format: "Do MMM YY"
      });
    }
  }
};
</script>

<style lang="scss" scope>
.qualification-icon {
  margin-right: 10px;
  background-color: rgba($primary, 0.1);
  border-radius: 4px;
  width: 56px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
